import * as React from 'react';
import { Control, useController } from 'react-hook-form';
import { CmdError } from '@commander-services/gui-components';

interface ICheckboxGroupOption {
  item: string;
  value: string | number;
  disabled?: boolean;
}

interface ICheckboxInputProps {
  label: string;
  name: string;
  id: string;
  options: ICheckboxGroupOption[];
  control: Control<any>;
  required?: boolean;
  disabled?: boolean;
  onChangeCallback?: (value: boolean) => void;
}

export default function CheckboxInputHookForm(props: ICheckboxInputProps) {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name: props.name,
    control: props.control,
    defaultValue: '',
  });

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    onChange(isChecked); // Update the form control value with boolean

    if (props.onChangeCallback) {
      props.onChangeCallback(isChecked);
    }
  };

  return (
    <div
      id={props.id}
      className={`checkbox-input-component form-group ${error && 'form-group-error'}`}
    >
      <label className="d-block form-label">
        {props.required && <span className="text-danger required-field-info">*</span>}
        {props.label}
      </label>
      <div className="d-block">
        {props.options.map((option, index) => (
          <div className="e-checkbox" key={`checkbox-${props.name}-${index}`}>
            <label data-cy={`checkbox-${option.value}`}>
              <input
                type="checkbox"
                value={option.value}
                checked={String(value) === String(option.value)}
                disabled={props.disabled || option.disabled}
                onChange={handleCheckboxChange}
                className="change-detail"
              />
              <span style={{ fontSize: '13px', fontFamily: 'Open Sans, sans-serif' }}>
                {option.item}
              </span>
              {error && <CmdError message={error.message} />}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
